// extracted by mini-css-extract-plugin
export default {"planSubTitle":"SeasonalPlanCard_planSubTitle__A59Tj","planDisclaimer":"SeasonalPlanCard_planDisclaimer__OSc0w"};